import { render, staticRenderFns } from "./tableClients.vue?vue&type=template&id=08e213a8&scoped=true"
import script from "./tableClients.vue?vue&type=script&lang=js"
export * from "./tableClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e213a8",
  null
  
)

export default component.exports